import { createFileRoute } from "@tanstack/react-router";

import { FicheUtilisateurPage } from "@/features/utilisateurs/FicheUtilisateurPage";

export const Route = createFileRoute("/_connecte/utilisateurs/$idUtilisateur")({
  component: Fiche,
});

function Fiche() {
  const { idUtilisateur } = Route.useParams();
  const id = idUtilisateur === "nouveau" ? null : Number(idUtilisateur);
  // La clé remonte la page d'une fiche à l'autre : pas d'état qui fuit entre deux comptes.
  return <FicheUtilisateurPage key={idUtilisateur} idUtilisateur={id !== null && Number.isInteger(id) ? id : -1} />;
}
